import { render, staticRenderFns } from "./MST_PREF_ALLOC.vue?vue&type=template&id=ff0e63c4&scoped=true"
import script from "./MST_PREF_ALLOC.vue?vue&type=script&lang=ts"
export * from "./MST_PREF_ALLOC.vue?vue&type=script&lang=ts"
import style0 from "./MST_PREF_ALLOC.vue?vue&type=style&index=0&id=ff0e63c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0e63c4",
  null
  
)

export default component.exports